// removed by extract-text-webpack-plugin
module.exports = {"choreContainer":"_3pz3p8S9vK3GhNldcMZqML","choreBubbleContainer":"_9H1P68Dsh6ruaYT8Upjg6","choreInfoBox":"_3RFuP7IW97IUW-j6bN0n4Q","choreName":"_2KSyLkTNZvZAQmq0wP1F1R","pointValue":"_1GIcRdYVDihLi-o-gVaAzn","timesPerWeek":"R7IJ9ezPVmIEdt7-D_lxr","iconBox":"_1bW2b026MXXSY_lWtCr2uA","editIcon":"_930d7URvHHztTJ0EpuVOv","trashIcon":"_2lYsCRULrwaToDLZWJ1qeH","choreInfoInterior":"PgpnSlEJyzaOPbA2Un4Zu"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/Chore.css
// module id = 382
// module chunks = 0